import { onDocumentEvent } from '@app/utils/domHelpers'
import $ from 'jquery'

const SUBMIT_TRIGGER_SELECTOR = '[data-behaviour="submit-trigger"]'

const queryAndSubmitByData = (e) => {
  e.preventDefault()

  const triggerElement = e.target.closest(SUBMIT_TRIGGER_SELECTOR)
  const formSelector = triggerElement.dataset.target
  const formElement = document.querySelector(formSelector)

  if (!formElement) {
    return
  }

  triggerElement.disabled = true
  $(formElement).submit()

  setTimeout(() => {
    triggerElement.disabled = false
  }, 1500)
}

onDocumentEvent(
  document,
  'mouseup',
  SUBMIT_TRIGGER_SELECTOR,
  queryAndSubmitByData
)
